import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export const useStyles = makeStyles(theme => {
	return {
		root: {},
		header: {
			fontSize: 38,
			fontWeight: 700,
			marginBottom: 40
		},
		optionalDateContainer: {
			display: 'flex',
			justifyContent: 'space-between'
		},
		optionalSelectorBox: {
			display: 'flex',
			justifyContent: 'space-between'
		},
		optionalBoxDivider: {
			marginTop: 20,
			marginBottom: 20
		},
		optionalTitle: {
			fontSize: 16,
			fontWeight: 500,
			marginBottom: 30
		},
		optionalInput: {
			marginBottom: 20
		},
		optionalInputStartDate: {
			marginBottom: 20,
			marginRight: 5
		},
		optionalInputEndDate: {
			marginBottom: 20,
			marginLeft: 5
		},
		additionalCommentsInputLabel: {
			whiteSpace: 'nowrap'
		}
	};
});
